import {useState} from 'react';
import { Form, redirect, useActionData, useNavigate, useNavigation } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, IconButton, Button, Alert, CircularProgress } from "@mui/material";
import api from "../../../hooks/useApi";
import CloseIcon from '@mui/icons-material/Close';
import PasswordField from '../../../components/PasswordField';

export async function action({ request, params }) {
    const formData = await request.formData();
    const payload = Object.fromEntries(formData.entries());
    if (payload.password !== payload.password_confirm) {
        return { error: { password_confirm: ['Паролі не збігаються'] } };
    }
    try {
        await api.post(`/api/users/partners/${params.user_id}/set-password/`, payload);
        return redirect('/all-users');
    } catch (error) {
        return {error: error.response?.data || {detail: 'Не вдалося змінити пароль.'}};
    }
}

export default function EditUserRights() {
    const actionData = useActionData();
    const navigate = useNavigate();
    const navigation = useNavigation();
    const isSubmitting = navigation.state === 'submitting';
    const [passwords, setPasswords] = useState({password: '', password_confirm: ''});
    const setGeneratedPassword = (value) => setPasswords({password: value, password_confirm: value});
    const errorText = actionData?.error && (typeof actionData.error === 'string'
        ? actionData.error : Object.values(actionData.error).flat().join(', '));
    return <Dialog open fullWidth maxWidth="sm" onClose={() => navigate('/all-users')}>
        <DialogTitle sx={{ pr: 6 }}>Зміна пароля
            <IconButton aria-label="Закрити" onClick={() => navigate('/all-users')} sx={{ position: 'absolute', right: 8, top: 8 }}><CloseIcon /></IconButton>
        </DialogTitle>
        <Form method="post">
            <DialogContent dividers>
                <Stack spacing={2} sx={{ pt: 1 }}>
                    {errorText && <Alert severity="error">{errorText}</Alert>}
                    <PasswordField
                        required
                        name="password"
                        label="Новий пароль"
                        value={passwords.password}
                        onChange={(value) => setPasswords((current) => ({...current, password: value}))}
                        onGenerate={setGeneratedPassword}
                    />
                    <PasswordField
                        required
                        name="password_confirm"
                        label="Підтвердіть новий пароль"
                        value={passwords.password_confirm}
                        onChange={(value) => setPasswords((current) => ({...current, password_confirm: value}))}
                        onGenerate={setGeneratedPassword}
                    />
                </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, flexWrap: 'wrap', gap: 1 }}>
                <Button onClick={() => navigate('/all-users')}>Скасувати</Button>
                <Button variant="contained" type="submit" disabled={isSubmitting}>{isSubmitting && <CircularProgress size={18} sx={{ mr: 1 }} />}Змінити пароль</Button>
            </DialogActions>
        </Form>
    </Dialog>;
}
